import { nanoquery } from '@nanostores/query'
import { manifest } from './manifest-store'
import { agentStore, userStore } from './stores'
import { SessionStatusType } from '../../models/User'
import type { AccountData } from '../../models/AccountData'

export const [createAccountInfoFetcherStore, createAccountInfoMutatorStore] = nanoquery({
  fetcher: async (): Promise<AccountData | undefined> => {
    const $userStore = userStore.get()
    const $user = $userStore.data

    if (!$user || $user.sessionStatus !== SessionStatusType.LOGGEDIN) {
      return
    }

    const $agentStore = agentStore.get()
    const $agent = $agentStore.data

    const $manifest = manifest.get()
    const { getAccountInfoClient } = await import(/* @vite-ignore */ $manifest.mfe_account.client.url)
    return getAccountInfoClient($agent)
  },
})

export const updateAccountInfo = createAccountInfoMutatorStore(async ({ revalidate }) => {
  const $manifest = manifest.get()
  const { getPaymentsClient, updateCardType } = await import(/* @vite-ignore */ $manifest.mfe_account.client.url)
  const paymentInfoRes = await getPaymentsClient()
  updateCardType(paymentInfoRes)
  revalidate('accountInfo')
  return
})
